class PaginatenNext extends HTMLElement {
  constructor() {
    super();
  }
  checkDisturber() {
    let grid_items = Array.from(this.section.querySelectorAll('.disturber-block, [pagination-child]'));
    grid_items = grid_items.sort((a,b) => Number(a.style.getPropertyValue('--position')) < Number(b.style.getPropertyValue('--position')) ? -1 : 1);
    let endIndex = grid_items.length;
    if(grid_items.length > 1) {
      let endReached = false;
      for (let i = 1; i < grid_items.length; i++) {
        const prev_index = Number(grid_items[i-1].style.getPropertyValue('--position'));
        const curr_index = Number(grid_items[i].style.getPropertyValue('--position'));
        if(Math.abs(curr_index - prev_index) > 1) {
          endReached = true;
          endIndex = i;
        }
        if(endReached) {
          grid_items[i].style.display = 'none';
        } else {
          grid_items[i].style.removeProperty('display');
        }
      }
    }
    const overlapCount = endIndex % 4;
    if(overlapCount > 0 && !!this.paginate_next){
      for (let i = endIndex-1; i > (endIndex - 1 - overlapCount); i--) {
        grid_items[i].style.display = 'none';
      }
    }
  }
  updateDOM() {
    const loadingText = this.getAttribute("loading-text");
    this.innerHTML = `<span>${loadingText}</span>`;
    if (!!this.section) {
      this.section.classList.add("loading");
      const section_id = this.section.getAttribute("id").split("shopify-section-").pop();
      if (!!section_id && !!this.paginate_next) {
        const fetch_url = new URL(this.paginate_next, location.origin);
        fetch_url.searchParams.set("section_id", section_id);
        fetch(fetch_url.href, {
          credentials: "same-origin",
          headers: { "X-Requested-With": "XMLHttpRequest" },
          method: "GET",
        })
          .then((response) => response.text())
          .then((data) => {
            const template = document.createElement("template");
            template.innerHTML = data.trim();
            const new_pagination_children = template.content.querySelectorAll("[pagination-parent] [pagination-child]");
            for (const child of new_pagination_children) {
              let index = child.style.getPropertyValue('--position');
              if(index) {
                index = Number(this.currentOffset) + Number(index);
                child.style.setProperty('--position', index);
              }
              this.pagination_parent.append(child);
            }
            const old_pagination_element = this;
            const new_pagination_element = template.content.querySelector("paginate-next");
            if (!!new_pagination_element) {
              old_pagination_element.replaceWith(new_pagination_element);
            } else {
              old_pagination_element.remove();
            }
            if (!!this.section) {
              this.section.classList.remove("loading");
            }
          })
          .catch(function (err) {
            if (!!this.section) {
              this.section.classList.remove("loading");
            }
            console.error(err);
          });
      }
    }
  }
  connectedCallback() {
    this.section = this.closest(".shopify-section");
    this.pagination_parent = this.section.querySelector("[pagination-parent]");
    this.paginate_next = this.getAttribute("paginate-next");
    this.currentOffset = this.pagination_parent.querySelectorAll("[pagination-child]").length;
    this.checkDisturber();
    if(!!this.paginate_next) {
      this.addEventListener("click", () => {
        this.updateDOM();
      });
    }
  }
}
customElements.define("paginate-next", PaginatenNext);